import { PackSizeUom } from '@control-tower/platform-item-catalog';
import { ICustomFieldDto } from '@pf/shared/util-platform';
import { asArraySafe } from '@pf/shared-utility';

export const KIT_COMPONENT_KEY_PREFIX = 'kit-component--' as const;

export const DEFAULT_NON_KIT_PACK_SIZE_UOM = PackSizeUom.Each;

export function buildKitComponentCustomFieldKey(componentId: string): string {
    return `${KIT_COMPONENT_KEY_PREFIX}${componentId}`;
}

export function parseComponentIdFromKitCustomFieldKey(
    key: string | undefined | null
): string | null {
    if (!key?.startsWith(KIT_COMPONENT_KEY_PREFIX)) {
        return null;
    }
    const id = key.slice(KIT_COMPONENT_KEY_PREFIX.length);
    return id.length > 0 ? id : null;
}

export function isKitComponentCustomFieldKey(
    key: string | undefined | null
): boolean {
    return !!key?.startsWith(KIT_COMPONENT_KEY_PREFIX);
}

export function partitionKitBomCustomFields(
    fields: ICustomFieldDto[] | undefined | null
): { kitBom: ICustomFieldDto[]; attributes: ICustomFieldDto[] } {
    const kitBom: ICustomFieldDto[] = [];
    const attributes: ICustomFieldDto[] = [];
    for (const f of asArraySafe(fields)) {
        if (isKitComponentCustomFieldKey(f.key)) {
            kitBom.push(f);
        } else {
            attributes.push(f);
        }
    }
    return { kitBom, attributes };
}

export function parseKitBomQuantity(value: string | null | undefined): number {
    const n = parseInt(String(value ?? ''), 10);
    return Number.isFinite(n) ? n : 0;
}

export function isPackSizeUomKit(packSizeUom: unknown): boolean {
    if (packSizeUom == null) {
        return false;
    }
    return String(packSizeUom).trim().toLowerCase() === 'kit';
}

export function mergeAttributeCustomFieldsWithKitBom(
    attributes: ICustomFieldDto[],
    kitBom: ICustomFieldDto[]
): ICustomFieldDto[] {
    return [...asArraySafe(attributes), ...asArraySafe(kitBom)];
}
